import { FC, useState } from "react";
import styles from "./FilterParametrs.module.scss";
import arrow from "../../images/icons/arrow.svg";
import InputRange from "../ui/InputRange/InputRange";

interface IFilterParametrs {
  setAge: (value: [number, number]) => void;
  setHeight: (value: [number, number]) => void;
  setWeight: (value: [number, number]) => void;
  setBust: (value: [number, number]) => void;
}
export const FilterParametrs: FC<IFilterParametrs> = ({
  setAge,
  setHeight,
  setBust,
  setWeight,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setIsOpen(false);
    }
  };

  return (
    <div className={styles.multidropdown} tabIndex={0} onBlur={handleBlur}>
      <button
        onClick={toggleDropdown}
        type="button"
        className={`${styles.multidropdownButton} ${
          isOpen && styles.multidropdownButton_active
        }`}
      >
        Angabe:
        <img
          src={arrow}
          className={`${styles.arrow} ${isOpen && styles.arrow_open}`}
          alt="Стрелка выпадающего списка"
        />
      </button>
      <ul className={`${styles.multidropdownMenu} ${isOpen && styles.active}`}>
        <li className={styles.multidropdownItem}>
          <InputRange
            label={"Alter:"}
            min={18}
            max={70}
            onRangeChange={setAge}
          />
        </li>
        <li className={styles.multidropdownItem}>
          <InputRange
            label={"BH-Größe"}
            min={1}
            max={12}
            onRangeChange={setBust}
          />
        </li>
        <li className={styles.multidropdownItem}>
          <InputRange
            label={"Größe:"}
            min={120}
            max={220}
            onRangeChange={setHeight}
          />
        </li>
        <li className={styles.multidropdownItem}>
          <InputRange
            label={"Gewicht:"}
            min={35}
            max={150}
            onRangeChange={setWeight}
          />
        </li>
      </ul>
    </div>
  );
};
